import { UserDTO } from '../network/api/types/compte/UserDTO';
import { getInfos } from './userService';
import { Entity } from '../network/api/types/compte/Entity';
import { MemberDTO } from '../network/api/types/compte/MemberDTO';

export function hasRightsToModify(
  entity: Entity,
  profilPro: MemberDTO,
): boolean {
  if (!entity || !profilPro) {
    return false;
  }
  const userManager = entity.rattachement.manager;
  const userNaturalManager = entity.rattachement.naturalManager;
  const targetManager = profilPro.gestionnaire;
  const targetNaturalManager = profilPro.gestionnaireNaturel;
  return (
    (userNaturalManager && !targetNaturalManager)
    || (userManager && !targetManager)
  );
}

export function hasRightToDelegate(
  entity: Entity,
  profilPro: MemberDTO,
): boolean {
  if (!profilPro || !entity) {
    return false;
  }
  const userNaturalManager = entity.rattachement.naturalManager;
  const targetManager = profilPro.gestionnaire;
  return userNaturalManager && !targetManager;
}

export function hasRightToRemoveDelegation(
  entity: Entity,
  profilPro: MemberDTO,
): boolean {
  if (!profilPro || !entity) {
    return false;
  }
  const userNaturalManager = entity.rattachement.naturalManager;
  const targetDelegatedManager = !profilPro.gestionnaireNaturel && profilPro.gestionnaire;
  return userNaturalManager && targetDelegatedManager;
}

export function hasRightToBlock(
  entity: Entity,
  user: UserDTO,
  profilPro: MemberDTO,
  userId: string,
): boolean {
  if (!profilPro || !user) {
    return false;
  }
  const targetID = getInfos().sub;
  return hasRightsToModify(entity, profilPro) && userId !== targetID;
}

export function hasRightToDeparture(
  entity: Entity,
  user: UserDTO,
  profilPro: MemberDTO,
  userId: string,
): boolean {
  if (!profilPro) {
    return false;
  }
  const isCollaborateur = profilPro.fonction === 'Collaborateur';
  return hasRightToBlock(entity, user, profilPro, userId) && isCollaborateur;
}
